import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-[#A3A3A3] group-hover:text-primary" }

import { onMounted, PropType } from 'vue'
import { IonContent, modalController } from '@ionic/vue'
import InlineSvg from 'vue-inline-svg'
import { useRouter } from 'vue-router'
import { useGrid } from 'vue-screen'
import { useGWAnalytics } from '@/plugins/analytics'
import { useGWAnalyticsBasePayload } from '@/plugins/analytics/composables/analyticsBasePayload'

type modalSize = 'sm' | 'md' | 'lg' | 'full'


export default /*#__PURE__*/_defineComponent({
  __name: 'GwModal',
  props: {
	canDismiss: { default: true, type: Boolean },
	cssClass: {  default: '', type: String },
	data: { default: undefined, type: Object },
	name: { default: 'Unknown modal', type: String },
	onClose: { default: undefined, type: Function as PropType<() => Promise<any>> },
	size: { default: 'sm', type: String as PropType<modalSize> },
},
  setup(__props) {

const props = __props;


const { track } = useGWAnalytics()
const { payload } = useGWAnalyticsBasePayload()
const grid = useGrid('tailwind')

onMounted(async () => {
	document.dispatchEvent(new CustomEvent('gwModalPresented', { detail: { page_name: props.name } }))
})

const router = useRouter()
const close = async () => {
	props.data?.redirectTo ? await router.push(props.data.redirectTo) : null
	try {
		track('click', {
			...payload.value,
			name: 'Close',
			page: props.name
		})
	} catch(err) {
		console.error(err)
	}
	if (props.onClose) await props.onClose()
	else modalController.dismiss(undefined, 'cancel')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), {
    ref: "content",
    class: _normalizeClass({
			'[--padding-start:0] [--padding-end:0] [--padding-top:0] [--padding-bottom:0]': __props.size === 'full'
		})
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["flex justify-center relative h-full sm:h-auto sm:pt-16 sm:mt-8", {
				'mx-auto': __props.size !== 'full',
				'max-w-[467px]': __props.size === 'sm',
				'max-w-[600px]': __props.size === 'md',
				'max-w-[768px]': __props.size === 'lg',
				'bg-white pt-4 pb-4 mt-[calc(2rem+var(--ion-safe-area-top))] sm:pt-20 px-4 sm:pb-12 rounded-lg h-auto': __props.cssClass === '-transparent'
			}])
      }, [
        (__props.canDismiss && __props.size !== 'full')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["group hover:bg-primaryLight rounded-full cursor-pointer h-[3.125rem] w-[3.125rem] bg-[#eee] absolute z-10 flex items-center justify-center transition-colors duration-300", {
					'right-4 top-4 sm:top-4': __props.cssClass === '-transparent',
					'right-0 top-[calc(2rem+var(--ion-safe-area-top))] sm:top-[var(--ion-safe-area-top)]': __props.cssClass !== '-transparent'
				}]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
            }, [
              _createElementVNode("span", _hoisted_1, [
                _createVNode(_unref(InlineSvg), {
                  src: require('@/assets/x-solid.svg'),
                  class: _normalizeClass({ 'w-4 h-4': !!_unref(grid).breakpoint, 'w-3 h-3': !_unref(grid).breakpoint })
                }, null, 8, ["src", "class"])
              ])
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["flex items-center flex-col", {
					'm-auto pt-24 -translate-y-12 sm:pt-0 sm:translate-y-0': __props.size !== 'full',
					'w-[330px]': __props.size === 'sm',
					'w-full': __props.size === 'md' || __props.size === 'lg' || __props.size === 'full',
					'-translate-y-4 pt-12': __props.cssClass === '-transparent'
				}])
        }, [
          _renderSlot(_ctx.$slots, "default", {
            content: (_ctx.$refs.content as any),
            data: __props.data
          })
        ], 2)
      ], 2)
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})